const doc = [({"da":({"js":({"components":({"school_classes":({"create_check_in_button":({"check_in_with_the_school_class":"Woof med klassen", "woof":"WOOF"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;